import BackendService from './BackendService';

async function getAIImages(key) {
  const keyword = (key || '').trim();
  return BackendService.getData('/ai-images/', {}, { key: keyword });
}

const AIImageService = {
  getAIImages,
};

export default AIImageService;
